const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);

// we are using es6 modules
export default isEmpty;



// WEBPACK FOOTER //
// ./src/validation/is-empty.js